const INIT_PLATFORM_API_PROVIDER_QUERY_PARAM = 'init-platform-api-provider';

const isInitPlatformApiProviderParam = (searchParamsMap: URLSearchParams) =>
  searchParamsMap.get(INIT_PLATFORM_API_PROVIDER_QUERY_PARAM) === 'true';

export {
  isInitPlatformApiProviderParam,
  INIT_PLATFORM_API_PROVIDER_QUERY_PARAM,
};
